export default __webpack_public_path__ + "static/media/blake-pedernales.4f68ae12.jpg";